import { useContext } from 'react';

import { SelfConnectionContext } from '@frontend/contexts';

export function useSelfConnections() {
  return useContext(SelfConnectionContext);
}
